<script lang="ts">
	import { PrivacyPage } from '#lib/websites/privacy/pages/PrivacyPage/index.js';
</script>

<PrivacyPage />
